import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Home() {
  const { session } = useAuth();
  const u = session.user;
  if (u.is_consultant || u.is_platform_admin) return <Navigate to="/consultant" replace />;
  if (session.memberships.length) return <Navigate to={`/org/${session.memberships[0].org_id}/dashboard`} replace />;
  return <Navigate to="/consultant" replace />;
}
